import styles from './Hero.module.scss'
import condolence from "../../../images/icons/condolence.svg";
import flower from "../../../images/icons/flower.svg";
import candle from "../../../images/icons/candle.svg";
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import moment from "moment";
import Mensenlinq from "@/Atoms/Icons/Mensenlinq";
import {datePlaceString} from "@/helpers/StringHelpers";

type HeroProps<T extends Record<string, unknown> = Record<string, unknown>> = T & {
  person: Person,
  stats: InteractionStats,
  claimed?: boolean,
  background?: string,
};
export default function Hero({person, stats, claimed, background}: HeroProps) {

  const {deceased, birth} = person

  const birthAndDeceased = (birth && deceased) ? `${birth} \u2022 ${deceased}` : birth || deceased

  const paperString = person.papers.map(paper => paper.title).join(', ')

  return <section className={`${styles.hero} ${claimed ? styles.claimed : ''}`}>
    <div className={`${styles.background} ${(claimed && background) ? styles.backgroundClaimed : ''}`}>
      {(claimed && background) ? <img src={background} alt={''}/> : <Mensenlinq className={styles.shape}/>}
    </div>
    <div className={`${styles.wrapper} container`}>

      {claimed && (
        <div className={styles.avatar}>
          {person.avatar?.url
            ? <img src={person.avatar.url} alt={person.name}/>
            : <Mensenlinq className={styles.avatarPlaceholder} />
          }
        </div>
      )}
      <h1 className={'pb-5'}>{person.name}</h1>
      <div>
        <p>{birthAndDeceased}</p>
        <p>{paperString}</p>
      </div>
      <div className={styles.stats}>
        <span><img src={condolence} alt={'Condoleances'}/><span>{stats.condolences}</span></span>
        <span><img src={flower} alt={'Bloemen'}/><span>{stats.flowers}</span></span>
        <span><img src={candle} alt={'Kaarsjes'}/><span>{stats.candles}</span></span>
      </div>

    </div>
  </section>
}
